import { Component, Vue } from 'vue-property-decorator';
@Component
export class NewRecommendMixin extends Vue {
    public compareRef(date) {
        if (date == this.dealTime(6)) {
            return "toDay";
        } else if (date == this.dealTime(9)) {
            return "tomorrow";
        } else if (date == this.dealTime(3)) {
            return "yesterDay";
        } else {
            return "rests";
        }
    }
    public dateCompare(date) {
        if (date == this.dealTime(6)) {
            return "今天";
        } else if (date == this.dealTime(9)) {
            return "明天";
        } else if (date == this.dealTime(3)) {
            return "昨天";
        } else {
            return date.slice(5);
        }
    }
    public dealTime(v) {
        const b = 24 * 60 * 60 * 1000
        const day = new Date();
        v == 3 ? day.setTime(day.getTime() - b) : v == 6 ? day.setTime(day.getTime()) : day.setTime(day.getTime() + b);
        const dayMon = (day.getMonth() + 1) >= 10 ? day.getMonth() + 1 : '0' + (day.getMonth() + 1)
        const dayDat = (day.getDate()) >= 10 ? day.getDate() : '0' + (day.getDate())
        const s = day.getFullYear() + "-" + dayMon + "-" + dayDat;
        return s
    }
    public footerCompare(date) {
        let tmp = Date.parse(String(new Date())).toString();
        tmp = tmp.substr(0, 10);
        const arr: any = this.$fn.toCompareTimes(tmp).split("-");
        const firsttime = arr[0].concat(arr[1], arr[2]);
        const arrs: any = date.split("-");
        const lasttime = arrs[0].concat(arrs[1], arrs[2]);
        if (firsttime >= lasttime) {
            return true;
        } else {
            return false;
        }
    }
    public mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.getLocation()
            }, 500);
        })
    }
    public getLocation() {
        const $refDay: any = this.$refs;
        let left;
        const main = (this as any).$refs.getBox.getBoundingClientRect().left;
        if ($refDay.toDay) {
            left = $refDay.toDay[0].getBoundingClientRect().left;
        } else if ($refDay.yesterDay) {
            left = $refDay.yesterDay[0].getBoundingClientRect().left;
        } else if ($refDay.tomorrow) {
            left = $refDay.tomorrow[0].getBoundingClientRect().left;
        } else {
            const num = $refDay.rests.length;
            left = $refDay.rests[Math.ceil(num / 2)].getBoundingClientRect().left;
        }
        $refDay.scrollToVS.scrollTo(
            {
                x: left - main
            },
            500
        );
    }
}
